/*************************************************************************
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { useEffect, useState } from "react";
import Cursor from "dc-preview-utils/src/components/Cursor/Cursor";
import { createURLFromBuffer } from "dc-preview-utils/src/Utils/UrlUtils";
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import { CURSOR_RENDITION_PRIORITY } from "constants/constants";
import { focusTabbableElementAtCaret } from "utils/CaretModeUtils";

export const CursorWrapper = ({ pageIndex, cursorInfo, zoomLevel, isCursorVisible, isDarkPageThemeEnabled }) => {
  const [imgUrl, setImgUrl] = useState(undefined);
  useEffect(() => {
    const cursorRect = {
      left: cursorInfo.xmin,
      right: cursorInfo.xmin + 1,
      top: cursorInfo.ymin,
      bottom: cursorInfo.ymax + 1
    };
    apiFactory.getExposedApis("preview", [publicApiNames.DOCUMENT], true, true).then(apis => {
      apis[publicApiNames.DOCUMENT]
        .getPageRendition({
          itemType: "page",
          zoomLevel,
          index: pageIndex,
          devicePixelRatio: 1,
          priority: CURSOR_RENDITION_PRIORITY,
          type: "page",
          showAnnots: 0,
          tileRect: cursorRect
        })
        .then(data => {
          const url = createURLFromBuffer(data.data.buffer, data.data.mimeType);
          setImgUrl(url);
        });
    });
    focusTabbableElementAtCaret(pageIndex);
  }, [cursorInfo]);
  return (
    <Cursor
      cursorImgUrl={imgUrl}
      cursorInfo={cursorInfo}
      zoomLevel={zoomLevel}
      isCursorVisible={isCursorVisible}
      {...(isDarkPageThemeEnabled && { imgStyle: { filter: "grayscale(1)" } })}
    />
  );
};
